const LINK_PROTOCOL_REGEX = /^https?:\/\//i
const LINK_REGEX = /^(https?:\/\/)?([a-z0-9]([a-z0-9-]*[a-z0-9])?\.)+[a-z]{2,}(:\d+)?([/?#]\S*)?$/i

export const isValidLink = (value: string) => LINK_REGEX.test(value.trim())

// Note: links are stored and opened as-is (href), so a link typed without a protocol gets https://
export const normalizeLink = (value: string) => {
  const trimmed = value.trim()
  if (!trimmed || LINK_PROTOCOL_REGEX.test(trimmed)) return trimmed
  return `https://${trimmed}`
}
